import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { globals } from "../../../../../misc/globals";
import { registerSgaAttempt } from "../../../../../misc/tools";
import BasePracticeScenario from "../../../../base-practice-scenario/BasePracticeScenario";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import GeneralProceduresSgaMain, { GeneralProceduresSgaMainConfig, GeneralProceduresSgaPart1Config } from "../GeneralProceduresSgaMain";

var sgaAttempts = 0;
export default class GeneralProceduresSgaPart1 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresSgaPart1Config {
		return this.scenarioConfig.part1Config;
	}
	constructor(private main: GeneralProceduresSgaMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private onAbort: () => void, private id: string, private scenarioConfig: GeneralProceduresSgaMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.step1SelectSize();
	}

	public increaseAttempt() {
		const context = this;
		sgaAttempts++; 
		if(context.config.onProcedureAttempted) {
			context.config.onProcedureAttempted(sgaAttempts);
		}
		if(sgaAttempts > 4) {
			sgaAttempts = 4;
		}

		if(sgaAttempts === 4) {
			if(context.config.onProcedureAttemptedMoreThan3Times) {
				context.config.onProcedureAttemptedMoreThan3Times();
			}
			// this._scenario.debriefLogFailedItem('You have attempted SGA more than 3');
		}
	}

	public step1SelectSize() {
		const context = this;
		var onDone = () => {
			context.scenario.uiWrapper.displaySGAMakeAttemptUI({
				onAbortedClicked: () => {
					if(context.config.onAbortClicked) {
						context.config.onAbortClicked();
					}

					if(context.onAbort) {
						context.onAbort();
					}
				},
				onMakeAttemptClicked: (selectedSga: string) => {
					registerSgaAttempt(context.scenario);
	
					if(context.config.onMakeAttemptClicked) {
						context.config.onMakeAttemptClicked(selectedSga);
					}
					context.step2IndicatorUI();
				}
			})
		}
		if(context.config.isAngelaScott) {
			this.increaseAttempt();
			context.scenario.displayMessage('Failed attempt, the mouth opening is too small', () => {
				context.scenario.toolbagId = context.scenario.uiWrapper.displayToolbag({
					isDisabled: false
				}, context.scenario.toolbagId);
			});
			return;
		}

		if(context.config.presetupText) {
			context.scenario.displayMessage(context.config.presetupText, () => {
				onDone();
			});
			return;
		}

		onDone();
	}

	public step2IndicatorUI() {
		const context = this;
		
		this.increaseAttempt()

		var propName = 'supraglotticattempt' + sgaAttempts;

		// context.playVideoChapter((context._videoChapters as any)[propName], () => {
		// })
		var nonDefaultAudio = (this.config as any)['attempt' + sgaAttempts + 'AudioPath']
		context.scenario.auscultateAudio = nonDefaultAudio ?? './assets/audio/sga/' + propName +'.mp3'
		// context.scenario.gameManager.SoundManager.playSound({
		// 	src: nonDefaultAudio ?? './assets/audio/sga/' + propName +'.mp3',
		// 	autoPlay: true,
		// 	enableClosedCaptioning: false,
		// 	muted: false,
		// 	volume: 1
		// });
		var onDoneWithPopup = context._scenario.doSomething('Inserting SGA');
		setTimeout(() => {
			context.main.loopVideo(this, context.config.insertingSgaVideoChapter());
			onDoneWithPopup();
			context.step3SqueezeAmbuBag();
		}, constants.doSomethingTimeout);
	}

	public step3SqueezeAmbuBag() {
		const context = this;
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>Squeezing Ambubag</p>`,
			onDismissed: () => {
				context.step4MovingAir();
			}
		})

		context.main.loopVideo(this, context.config.squeezeAmbuBagVideoChapter());

		if(context.scenarioConfig.isAttemptSuccessful()) {
			(context.scenario as BasePracticeScenario).stopApneaTimerForEntireRunThrough();
		} else if(context.scenarioConfig.isTempSuccess()) {
			(context.scenario as BasePracticeScenario).resetApneaTimerForEntire();
		}
	}

	public step4MovingAir() {
		const context = this;
		const isSuccessful = this.scenarioConfig.isAttemptSuccessful() || this.scenarioConfig.isTempSuccess();
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>${ isSuccessful ? 'Moving Air' : 'We\'re encountering some resistance.'}</p>`,
			onDismissed: () => {
			}
		})

		if(isSuccessful) {
			context.scenario.gameManager.SoundManager.playSound({
				src: './assets/audio/bvm/BVMmovingair.mp3',
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 1
			});
		}
		
		context.onDone();
		// context.playVideoChapter(context._videoChapters.step4RTMovingAir, () => {
		// 	context.onDone();
		// })
	}
}